// extracted by mini-css-extract-plugin
export default {"sRoundButton":"RectangleButtonDisabled_sRoundButton__Oe9Zm"};